import { dispatch } from '../../store/'
import { db } from '../firebase';
import { fetchImpUsers, fetchImpRequesters, fetchUnlockedUsers } from '../../actions/adminUserMgm'
import { passwordGenerator } from '../../js/helper'
import moment from 'moment'
import _ from 'lodash'
import store from '../../store'
const impUsersRef = db.ref('/api/importedUsers/')
const unlockedUsersRef = db.ref('/usersUnlocked/')
const usersRef = db.ref('/users/')
const usersDeactivatedRef = db.ref('/usersDeactivated')
const usersOnlineRef = db.ref('/userOnline')




const getAppUsers = async () => {
    const newArr = []
    const deacUsersIds = []
    const usersSnap = await usersRef.orderByChild('appUser').equalTo(true).once('value')
    const usersObject = await usersSnap.val();
    const usersArr = await _.values(usersObject)
    const deactivatedUsersSnap = await usersDeactivatedRef.once('value')
    const deacUsersExists = await deactivatedUsersSnap.exists()
    // exit and return org usersArr if is no User deaktivated
    if (!deacUsersExists) return usersArr
    const deactivatedUsers = await _.values(deactivatedUsersSnap.val())
    await deactivatedUsers.map(deacUser => deacUsersIds.push(deacUser.id))

    await usersArr.map(user => {
        if(deacUsersIds.indexOf(user.id)>=0) {
            return null
        } else {
            return newArr.push(user)
        }
    })
    
    return newArr
}

const getUnlockedUsers = async (watch) => {

    if(!watch) unlockedUsersRef.off()
    return unlockedUsersRef.on('value', unlockedUsersSnap => {
        if(!unlockedUsersSnap.exists()) return fetchUnlockedUsers({})
        const unlockedUsers = unlockedUsersSnap.val()
          
        return fetchUnlockedUsers(unlockedUsers)
    })
}

const getImpUsersRequester = async (option) => {
    //const impUsersSnap = await impUsersRef.once('value')
    if(option==='reset') fetchImpUsers(null)
    let impUsersArr = []
    //await getUnlockedUsers()

    impUsersRef.orderByChild('role').equalTo("requester").once('value', (impUsers) => {
    
        if(impUsers===null || impUsers==='undefined') return null
        impUsersArr = _.values(impUsers.val())
      
        return fetchImpRequesters(impUsersArr)
    })
    
   // if(!impUsersSnap.exists()) return null
    //await fetchImpUsers(impUsersSnap.val())
    
    return 'done'
}

const checkUser = async (extId) =>{
   
    const userSnap =  await usersRef.orderByChild('extId').equalTo(extId).once('value')
    const isExisting = userSnap.exists()

    if(!isExisting)return false
    const users = await userSnap.val()
   
    const userId = Object.keys(users)
    const user = users[userId]
    return user.id
}

const setImpUser = async (user) => {
   
    const userExists = await checkUser(user.extId)

    if(userExists) return userExists
    const newPushKey = usersRef.push().key
    const newUser = {
        pkw: user.car,
        email: user.email,
        extId: user.extId,
        id: newPushKey,
        mobil: user.mobil,
        myTasks: user.myTasks,
        name: user.name,
        ort: user.ort,
        plz: user.plz,
        strasse: user.strasse,
        telefon: user.telefon,
        role: user.role,
        userInfo: user.userInfo,
        appUser: false,
    }
    usersRef.child(newPushKey).set(newUser)
    return newPushKey
}

const getImpUsers = async () => {
    //const impUsersSnap = await impUsersRef.once('value')
    let impUsersArr = []
    //await getUnlockedUsers()
    
    await impUsersRef.on('value', async impUsersSnap => {
        if(!impUsersSnap.exists()) return null
        const unlockedUsers = store.getState().adminUserMgm.unlockedUsers || []
        //impUsersArr = _.values(impUsers.val())
        const impUsers = impUsersSnap.val()
        
        if(impUsersArr.length>0)
            impUsersArr.splice(0, impUsersArr.length)
        _.map(impUsers, impUser => {
            if(typeof(impUser)==='undefined')return null
            const isUnlockedUser = unlockedUsers.indexOf(impUser.extId)!==-1
            if(!isUnlockedUser) impUsersArr.push(impUser)

            //console.log(impUser)
            //const isUnlockedUser = unlockedUsers.includes(impUser.extId) 
           // console.log(isUnlockedUser)

        })
        return fetchImpUsers(impUsersArr)
    })
    
   // if(!impUsersSnap.exists()) return null
    //await fetchImpUsers(impUsersSnap.val())
    
    return 'done'
}

const handleUnlockUser = (unlockedUser) => {
    const tempUserRef = db.ref('/api/tempUser')
    //const { extId } = unlockedUser
    getImpUsers()
    unlockedUser.password = passwordGenerator()
    // all register stuff done by fb cloud functions createUser.)
    return tempUserRef.push(unlockedUser)
}

const handleDeativateUser = (user) => {
    const userId = user.id
    usersDeactivatedRef.child(userId).set({...user})
    
}

const getUserProfile = async (userId) => {
    const userProfileSnap = await usersRef.child(userId).once('value')
    return userProfileSnap.val()
}

const getConnectedEvent = async (eventId) => {
    const eventSnap = await db.ref('/connectedEvents').child(eventId).once('value')
    const event = eventSnap.val()
    return event 
}

const listenUsersOnline = async (state) => {
    if(state===false) usersOnlineRef.off('value')
   
    usersOnlineRef.on('value', async snap => {
        const onlineUsersArr = []
        if(!snap.exists()) return onlineUsersArr
        const onlineUsers = _.values(snap.val())  
        const promises = onlineUsers.map( async onlineUser => {
            if(!onlineUser.userId) return 'Error! no User ID'
            const newUserProfile = await getUserProfile(onlineUser.userId)
            newUserProfile.loggedIn =  await moment(onlineUser.loggedIn).format('LLL')
            onlineUsersArr.push(newUserProfile)
        })
        await Promise.all(promises)
        return dispatch({type: 'FETCH_USERS_ONLINE', payload: onlineUsersArr})
    })
   
}


export { 
    getImpUsersRequester,
    getAppUsers,
    setImpUser,
    handleUnlockUser,
    getImpUsers,
    getUnlockedUsers,
    handleDeativateUser,
    listenUsersOnline,
    getUserProfile,
    getConnectedEvent
}


// WEBPACK FOOTER //
// ./src/firebase/database/handleUserMgm.js